"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Delete;

var _Delete = require("@adobe/react-spectrum-workflow/dist/Delete");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Delete(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Delete.A4uDelete, null));
}